import { forwardRef } from 'react';

import { TimeField as MuiTimeField } from '@mui/x-date-pickers/TimeField';

import AutocompleteField from './AutocompleteField';

const DEFAUT_MINUTES_STEP = 15;

function generateTimes(stepMinutes) {
  const times = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += stepMinutes) {
      const hh = String(h).padStart(2, '0');
      const mm = String(m).padStart(2, '0');
      times.push(`${hh}:${mm}`);
    }
  }
  return times.map((t) => ({label: t, value: t}));
}

export const TimeSelectField = forwardRef((props, ref) => {
  const { minutesStep, ...rest} = props;
  return (
    <AutocompleteField
      ref={ref}
      fullWidth
      clearOnEscape
      disableClearable={false}
      openOnFocus
      autoHighlight
      options={generateTimes(minutesStep || DEFAUT_MINUTES_STEP)}
      {...rest}
    />
  );
});

TimeSelectField.displayName = 'TimeSelectField';

export const TimeField = forwardRef((props, ref) => {
  const {onBlur, required, fullWidth, helperText, error, slotProps, ...rest} = props;
  return (
    <MuiTimeField
      ref={ref}
      slotProps={{
        textField: {
          onBlur,
          required,
          fullWidth,
          helperText,
          error,
        },
        ...slotProps,
      }}
      {...rest}
    />
  );
});
TimeField.displayName = 'TimeField';
export default TimeField;


